// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-card-container {
  position: relative;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.16), 0 -3px 8px -6px rgba(0, 0, 0, 0.16);
  background-color: var(--base_color2);
}
.simple-card-container.fullWidth {
  width: 100%;
}
.simple-card-container .simple-card-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.simple-card-container .simple-card-title-container .simple-card-title {
  font-weight: 600;
  font-size: 22px;
  margin: 0;
}
.simple-card-container .simple-card-title-container .simple-card-filter-text {
  color: var(--gray_dark2);
}
.simple-card-container .grid-single-col {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.simple-card-container .simple-card-tooltip-container {
  margin: 0 0 0 8px;
  cursor: help;
  display: inline-block;
  height: 24px;
  vertical-align: sub;
}`, "",{"version":3,"sources":["webpack://./src/components/SimpleCard/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,gFAAA;EACA,oCAAA;AACF;AAAE;EACE,WAAA;AAEJ;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAAI;EACE,gBAAA;EACA,eAAA;EACA,SAAA;AAEN;AAAI;EACE,wBAAA;AAEN;AAEE;EACE,aAAA;EACA,0BAAA;EACA,WAAA;AAAJ;AAGE;EACE,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AADJ","sourcesContent":[".simple-card-container {\n  position: relative;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.16), 0 -3px 8px -6px rgba(0, 0, 0, 0.16);\n  background-color: var(--base_color2);\n  &.fullWidth {\n    width: 100%;\n  }\n\n  .simple-card-title-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .simple-card-title {\n      font-weight: 600;\n      font-size: 22px;\n      margin: 0;\n    }\n    .simple-card-filter-text {\n      color: var(--gray_dark2);\n    }\n  }\n\n  .grid-single-col {\n    display: grid;\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .simple-card-tooltip-container {\n    margin: 0 0 0 8px;\n    cursor: help;\n    display: inline-block;\n    height: 24px;\n    vertical-align: sub;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
